import React from 'react'

const PaymentTypeDetail = () => {
  return (
    <div>PaymentTypeDetail</div>
  )
}

export default PaymentTypeDetail